(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function parseConfig(root) {
    const script = root.querySelector('[data-deferred-hero-config]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch {
      return null;
    }
  }

  /*function pickVideoUrl(config) {
    if (!config) return '';
    const bp = Number(config.breakpoint) || 768;
    const isMobile = window.innerWidth < bp;
    return (isMobile ? config.mobile : config.desktop) || config.desktop || config.mobile || '';
  }*/

  function pickVideoUrl(config) {

    if (!config) return '';
    const STORAGE_KEY = 'user_gender';
    let gender = '';
    try {
      gender = (localStorage.getItem(STORAGE_KEY) || '').toLowerCase();
    } catch (e) {}
    const bp = Number(config.breakpoint) || 768;
    const isMobile = window.innerWidth < bp;

    // Male selected
    if (gender === 'male') {
      const maleVideo = isMobile
        ? (config.mobileMale || config.desktopMale)
        : config.desktopMale;

      if (maleVideo) {
        return maleVideo;
      }

      // Fallback to female/default
      return (isMobile ? config.mobile : config.desktop)
        || config.desktop
        || config.mobile
        || '';
    }

    // Female or default
    return (isMobile ? config.mobile : config.desktop)
        || config.desktop
        || config.mobile
        || '';
  }  

  function pickPosterUrl(config) {
    if (!config) return '';
    const bp = Number(config.breakpoint) || 768;
    const isMobile = window.innerWidth < bp;
    return (isMobile ? config.posterMobile : config.poster) || config.poster || '';
  }

  class DeferredVideoHero {
    constructor(root) {
      this.root = root;
      this.video = root.querySelector('.deferred-hero__video');
      this.config = parseConfig(root);
      this.revealed = false;
      this.loading = false;
      this.currentSrc = '';
      this.fallbackTimer = null;
      this.resizeTimer = null;
      this.lastBreakpointSide = null;

      root.deferredVideoHero = this;

      this.onWindowLoad = this.onWindowLoad.bind(this);
      this.onCanPlay = this.onCanPlay.bind(this);
      this.onLoadedData = this.onLoadedData.bind(this);
      this.onTransitionEnd = this.onTransitionEnd.bind(this);
      this.onResize = this.onResize.bind(this);

      this.showPoster();
      this.bindEvents();
      this.scheduleLoad();
    }

    prefersReducedMotion() {
      return REDUCED_MOTION.matches;
    }

    bindEvents() {
      window.addEventListener('resize', this.onResize);

      if (this.video) {
        this.video.addEventListener('canplay', this.onCanPlay);
        this.video.addEventListener('loadeddata', this.onLoadedData);
        this.video.addEventListener('transitionend', this.onTransitionEnd);
      }
    }

    scheduleLoad() {
      if (this.prefersReducedMotion()) return;

      if (document.readyState === 'complete') {
        this.loadVideo();
      } else {
        window.addEventListener('load', this.onWindowLoad, { once: true });
      }
    }

    onWindowLoad() {
      this.loadVideo();
    }

    showPoster() {
      const poster = pickPosterUrl(this.config);
      this.revealed = false;
      this.loading = false;
      this.clearFallback();

      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();

        if (poster) {
          this.video.setAttribute('poster', poster);
        } else {
          this.video.removeAttribute('poster');
        }
      }

      if (poster) {
        this.root.style.setProperty('--deferred-hero-poster-url', `url('${poster}')`);
        this.root.classList.add('deferred-hero--has-poster');
      } else {
        this.root.style.removeProperty('--deferred-hero-poster-url');
        this.root.classList.remove('deferred-hero--has-poster');
      }

      this.root.classList.remove('deferred-hero--video-ready');
      this.currentSrc = '';
    }

    loadVideo() {
      if (this.prefersReducedMotion()) return;
      if (!this.video || !this.config) return;

      const url = pickVideoUrl(this.config);
      if (!url) return;

      this.loading = true;
      this.revealed = false;
      this.clearFallback();
      this.root.classList.remove('deferred-hero--video-ready');

      if (this.currentSrc !== url) {
        this.currentSrc = url;
        this.video.src = url;
      }

      this.video.load();
      this.lastBreakpointSide = window.innerWidth < (Number(this.config.breakpoint) || 768) ? 'mobile' : 'desktop';

      this.fallbackTimer = window.setTimeout(() => {
        if (this.loading && !this.revealed) this.revealVideo();
      }, 10000);
    }

    onCanPlay() {
      if (this.loading && !this.revealed) this.revealVideo();
    }

    onLoadedData() {
      if (this.loading && !this.revealed) this.revealVideo();
    }

    revealVideo() {
      if (this.revealed || !this.video) return;

      this.revealed = true;
      this.loading = false;
      this.clearFallback();

      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }

      this.root.classList.add('deferred-hero--video-ready');
    }

    onTransitionEnd(event) {
      if (event.target !== this.video || event.propertyName !== 'opacity') return;
      if (!this.root.classList.contains('deferred-hero--video-ready')) return;

      this.video.removeAttribute('poster');
      this.root.style.removeProperty('--deferred-hero-poster-url');
      this.root.classList.remove('deferred-hero--has-poster');
    }

    onResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(() => this.handleResize(), 150);
    }

    handleResize() {
      if (this.prefersReducedMotion()) return;
      if (!this.config) return;

      const bp = Number(this.config.breakpoint) || 768;
      const side = window.innerWidth < bp ? 'mobile' : 'desktop';
      const nextUrl = pickVideoUrl(this.config);

      if (!nextUrl) return;

      if (side === this.lastBreakpointSide && this.currentSrc === nextUrl) return;

      this.lastBreakpointSide = side;
      this.showPoster();
      this.loadVideo();
    }

    clearFallback() {
      if (this.fallbackTimer) {
        window.clearTimeout(this.fallbackTimer);
        this.fallbackTimer = null;
      }
    }

    destroy() {
      this.clearFallback();
      window.clearTimeout(this.resizeTimer);
      window.removeEventListener('load', this.onWindowLoad);
      window.removeEventListener('resize', this.onResize);

      if (this.video) {
        this.video.pause();
        this.video.removeEventListener('canplay', this.onCanPlay);
        this.video.removeEventListener('loadeddata', this.onLoadedData);
        this.video.removeEventListener('transitionend', this.onTransitionEnd);
        this.video.removeAttribute('src');
        this.video.load();
      }

      this.root.classList.remove('deferred-hero--has-poster', 'deferred-hero--video-ready');
      this.root.removeAttribute('data-deferred-hero-init');
      delete this.root.deferredVideoHero;
    }
  }

  function initDeferredVideoHeroes(root = document) {
    root.querySelectorAll('[data-deferred-hero]:not([data-deferred-hero-init])').forEach((el) => {
      el.setAttribute('data-deferred-hero-init', '');
      new DeferredVideoHero(el);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initDeferredVideoHeroes());

  document.addEventListener('shopify:section:load', (event) => {
    initDeferredVideoHeroes(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-deferred-hero]').forEach((el) => {
      el.deferredVideoHero?.destroy();
    });
  });
})();
